<template>
    <rkm-layout-body title="Lista de banners">
        <template v-slot:actions>
            <rkm-button
                @click="$router.push({ name: 'parametrizacao-banner-create' })"
                color="primary"
                authorize="store-parametrizacao-banner"
            >
                Cadastrar banner
            </rkm-button>
        </template>

        <rkm-layout-content>
            <List />
        </rkm-layout-content>
    </rkm-layout-body>
</template>

<script>
// Components.
import List from '@/components/parametrizacao/banners/List'

export default {
    components: {
        List,
    },
}
</script>
